import { render, staticRenderFns } from "./proxy-ktzh.vue?vue&type=template&id=465f095e&"
import script from "./proxy-ktzh.vue?vue&type=script&lang=js&"
export * from "./proxy-ktzh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports